'use client';

import { Suspense, useRef } from 'react';
import dynamic from 'next/dynamic';
import { RouteKeepAlive } from '@/components/layout/route-keep-alive';
import Footer from '@/components/layout/footer';
import { useHeightControl } from '../use-height-control';

const TabMenu = dynamic(() => import('@/components/layout/tab-menu'), {
  ssr: false,
});

function MainContent({ children }: { children: React.ReactNode; }) {
  const mainLayoutRef = useRef<HTMLDivElement>(null);

  return (
    <main ref={mainLayoutRef} className="flex-1 relative flex flex-col overflow-scroll">
      <RouteKeepAlive>
        <Suspense>{children}</Suspense>
      </RouteKeepAlive>
      <Footer />
    </main>
  );
}

export default function NonActivityLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useHeightControl();
  return (
    <>
      <TabMenu />
      <Suspense
        fallback={
          <main className="flex-1 relative hide-scrollbar overflow-hidden">
            <Suspense>{children}</Suspense>
          </main>
        }
      >
        <MainContent>{children}</MainContent>
      </Suspense>
    </>
  );
}


